import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import AzioneAccount, { azioneDaUrl } from "./pages/AzioneAccount";
import { AuthProvider } from "./contexts/AuthContext";
import { ToastProvider } from "./utils/Toast";
import ConfirmProvider from "./utils/ConfirmProvider";
import ErrorBoundary from "./components/ErrorBoundary";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { installaProtezioneChiusuraModali } from "./utils/protezioneChiusuraModali";
import { applicaDimensioneTesto } from "./utils/preferenzeDispositivo";
import { installaSegnaleFinestre } from "./utils/finestreAperte";
import { installaIndietroChiudeFinestre } from "./utils/indietroChiudeFinestre";

// Le finestre non si chiudono più se si preme il mouse dentro e lo si rilascia fuori
installaProtezioneChiusuraModali();
// Testo più grande sul telefono, se scelto in Impostazioni → Profilo (utils/preferenzeDispositivo.js)
applicaDimensioneTesto();
// Con una finestra aperta i pulsanti fissi in basso a destra si nascondono (utils/finestreAperte.js)
installaSegnaleFinestre();
// il tasto «indietro» chiude prima la finestra aperta (prima dell'app: vedi il file)
installaIndietroChiudeFinestre();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <ToastProvider>
          <ConfirmProvider>
            {/* Link delle email Nexiora (password, conferma email): pagina dedicata, con o senza accesso */}
            {azioneDaUrl() ? <AzioneAccount /> : <App />}
          </ConfirmProvider>
        </ToastProvider>
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// Nuova versione disponibile — mai attivata in silenzio: un banner fisso, sempre visibile,
// resta lì finché l'utente non clicca "Aggiorna ora" (nessuna scadenza automatica, nessuna
// ricarica a sorpresa mentre magari sta compilando un form). Scritto in DOM puro (non
// componenti React) perché gira fuori dall'albero React, prima che i Provider siano pronti.
function mostraBannerAggiornamento(registration) {
  if (document.getElementById("nexiora-update-banner")) return;
  const banner = document.createElement("div");
  banner.id = "nexiora-update-banner";
  banner.style.cssText = "position:fixed;left:0;right:0;bottom:0;z-index:99999;background:#1e1b4b;color:#fff;padding:12px 20px;display:flex;align-items:center;justify-content:center;gap:14px;font-family:'Inter',sans-serif;font-size:13px;box-shadow:0 -2px 12px rgba(0,0,0,.2);";
  banner.innerHTML = `
    <span>🔄 È disponibile una nuova versione di Nexiora.</span>
    <button id="nexiora-update-btn" style="background:#7c3aed;color:#fff;border:none;border-radius:7px;padding:7px 16px;font-size:13px;font-weight:700;cursor:pointer;font-family:'Inter',sans-serif;">Aggiorna ora</button>
  `;
  document.body.appendChild(banner);
  document.getElementById("nexiora-update-btn").onclick = () => {
    let ricaricato = false;
    const ricarica = () => { if (ricaricato) return; ricaricato = true; window.location.reload(); };
    navigator.serviceWorker.addEventListener("controllerchange", ricarica);
    if (registration.waiting) registration.waiting.postMessage({ type: "SKIP_WAITING" });
    // Se la versione nuova si è già attivata altrove (un'altra scheda) o non risponde,
    // si ricarica comunque: il pulsante non deve mai restare senza effetto.
    setTimeout(ricarica, registration.waiting ? 4000 : 0);
  };
}

serviceWorkerRegistration.register({
  onUpdate: (registration) => mostraBannerAggiornamento(registration),
});
